export default __webpack_public_path__ + "static/B0314-8f23389ff05f9c3efa460a171ad2231b.png";